import heartbeat from "../../hbs/heartbeat.hbs";

import accountingReport from "../../hbs/accountingReport.hbs";
import employerReportV2 from "../../hbs/employerReportV2.hbs";
import employerReportV2Page1 from "../../hbs/employerReportV2Page1.hbs";
import paymentReportV2 from "../../hbs/paymentReportV2.hbs";
import summaryReport from "../../hbs/summaryReport.hbs";
import authorizationPerson from "../../hbs/authorizationPerson.hbs";
import authorizationCompany from "../../hbs/authorizationCompany.hbs";
import authorizationRaksa from "../../hbs/authorizationRaksa.hbs";
import invoice from "../../hbs/invoice.hbs";
import kycCompany from "../../hbs/kycCompany.hbs";
import eSalary from "../../hbs/eSalary.hbs";
import invoiceList from "../../hbs/invoiceList.hbs";
import calendar from "../../hbs/calendar.hbs";

import paymentSummaryReportV2 from "../../hbs/paymentSummaryReportV2.hbs";
import salarySlipV2 from "../../hbs/salarySlipV2.hbs";
import salarySlipV2Page1 from "../../hbs/salarySlipV2Page1.hbs";
import accountingReportHead from "../../hbs/partials/accountingReportHead.hbs";
import accountingTable from "../../hbs/partials/accountingTable.hbs";
import contractPartiesContactDetailsV2 from "../../hbs/partials/contractPartiesContactDetailsV2.hbs";
import document from "../../hbs/partials/document.hbs";
import employerCalculationAdditionalInfoV2 from "../../hbs/partials/employerCalculationAdditionalInfoV2.hbs";
import employerCalculationTablesV2 from "../../hbs/partials/employerCalculationTablesV2.hbs";
import employerContractDetailsV2 from "../../hbs/partials/employerContractDetailsV2.hbs";
import employerReportHeadV2 from "../../hbs/partials/employerReportHeadV2.hbs";
import page from "../../hbs/partials/page.hbs";
import partial from "../../hbs/partials/partial.hbs";
import paymentReportHeadV2 from "../../hbs/partials/paymentReportHeadV2.hbs";
import paymentSummaryReportHeadV2 from "../../hbs/partials/paymentSummaryReportHeadV2.hbs";

import paymentTablesV2 from "../../hbs/partials/paymentTablesV2.hbs";
import workerCalculationAdditionalInfoV2 from "../../hbs/partials/workerCalculationAdditionalInfoV2.hbs";
import workerCalculationTablesV2 from "../../hbs/partials/workerCalculationTablesV2.hbs";
import workerContractDetailsV2 from "../../hbs/partials/workerContractDetailsV2.hbs";
import workerCumulativeTables from "../../hbs/partials/workerCumulativeTables.hbs";
import workerDeductionWarningsV2 from "../../hbs/partials/workerDeductionWarningsV2.hbs";
import workerReportHeadV2 from "../../hbs/partials/workerReportHeadV2.hbs";
import defaultFooter from "../../hbs/partials/defaultFooter.hbs";
import defaultHeader from "../../hbs/partials/defaultHeader.hbs";
import img2 from "../../hbs/partials/img2.hbs";
import logo from "../../hbs/partials/logo.hbs";
import pageNumber from "../../hbs/partials/pageNumber.hbs";
import totalPages from "../../hbs/partials/totalPages.hbs";
import summaryReportHead from "../../hbs/partials/summaryReportHead.hbs";
import summaryReportTable from "../../hbs/partials/summaryReportTable.hbs";
import iamPerson from "../../hbs/partials/iamPerson.hbs";
import invoiceHead from "../../hbs/partials/invoiceHead.hbs";
import invoiceTable from "../../hbs/partials/invoiceTable.hbs";
import totalsReport from "../../hbs/totalsReport.hbs";
import totalsTables from "../../hbs/partials/totalsTables.hbs";
import totalsHead from "../../hbs/partials/totalsHead.hbs";
import workerSummaryReport from "../../hbs/workerSummaryReport.hbs";
import workerSummaryReportHead from "../../hbs/partials/workerSummaryReportHead.hbs";
import workerSummaryReportTable from "../../hbs/partials/workerSummaryReportTable.hbs";

export const hbsTemplates = {
  heartbeat,
  accountingReport,
  employerReportV2,
  employerReportV2Page1,
  paymentReportV2,
  paymentSummaryReportV2,
  salarySlipV2,
  salarySlipV2Page1,
  accountingReportHead,
  accountingTable,
  contractPartiesContactDetailsV2,
  document,
  employerCalculationAdditionalInfoV2,
  employerCalculationTablesV2,
  employerContractDetailsV2,
  employerReportHeadV2,
  page,
  partial,
  paymentReportHeadV2,
  paymentSummaryReportHeadV2,
  paymentTablesV2,
  workerCalculationAdditionalInfoV2,
  workerCalculationTablesV2,
  workerContractDetailsV2,
  workerCumulativeTables,
  workerDeductionWarningsV2,
  workerReportHeadV2,
  defaultFooter,
  defaultHeader,
  img2,
  logo,
  pageNumber,
  totalPages,
  summaryReport,
  summaryReportHead,
  summaryReportTable,
  authorizationPerson,
  authorizationCompany,
  authorizationRaksa,
  iamPerson,
  invoice,
  invoiceHead,
  invoiceTable,
  kycCompany,
  eSalary,
  totalsReport,
  totalsTables,
  totalsHead,
  workerSummaryReport,
  workerSummaryReportHead,
  workerSummaryReportTable,
  invoiceList,
  calendar
};